// extracted by mini-css-extract-plugin
export default {"locationsButton":"JO3yI","locationsIcon":"MbnFs"};